
/* Endboss 3 – Native App Mode Drawer
   - translate3d GPU animation
   - velocity based swipe
   - overscroll resistance
   - composited layer
*/
(function(){
  const drawer = document.querySelector('#mobileMenu');
  if(!drawer) return;

  const openBtns = document.querySelectorAll('[data-drawer-open]');
  const closeBtns = document.querySelectorAll('[data-drawer-close]');

  drawer.style.willChange = "transform";
  drawer.style.transform = "translate3d(-100%,0,0)";
  drawer.style.transition = "transform .32s cubic-bezier(.22,.61,.36,1)";

  let startX = 0;
  let currentX = 0;
  let lastMoveTime = 0;
  let velocity = 0;
  let open = false;

  function lockScroll(state){
    document.body.classList.toggle('nav-open', state);
  }

  function setTranslate(x){
    drawer.style.transform = "translate3d("+x+"px,0,0)";
  }

  function openDrawer(){
    open = true;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    setTranslate(0);
    lockScroll(true);
  }

  function closeDrawer(){
    open = false;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    setTranslate(-drawer.offsetWidth);
    lockScroll(false);
  }

  // init closed
  requestAnimationFrame(()=>{
    setTranslate(-drawer.offsetWidth);
  });

  openBtns.forEach(btn=>{
    btn.addEventListener('click', e=>{
      e.preventDefault();
      openDrawer();
    });
  });

  closeBtns.forEach(btn=>{
    btn.addEventListener('click', e=>{
      e.preventDefault();
      closeDrawer();
    });
  });

  document.addEventListener('keydown', e=>{
    if(e.key === 'Escape') closeDrawer();
  });

  // Touch gesture physics
  drawer.addEventListener('touchstart', e=>{
    startX = e.touches[0].clientX;
    currentX = startX;
    lastMoveTime = Date.now();
    drawer.style.transition = "none";
  },{passive:true});

  drawer.addEventListener('touchmove', e=>{
    const x = e.touches[0].clientX;
    const dx = x - startX;
    const now = Date.now();

    velocity = (x - currentX) / (now - lastMoveTime + 1);
    currentX = x;
    lastMoveTime = now;

    if(dx < 0){
      // overscroll resistance
      setTranslate(dx * 0.9);
    }
  },{passive:true});

  drawer.addEventListener('touchend', ()=>{
    drawer.style.transition = "transform .32s cubic-bezier(.22,.61,.36,1)";

    if(velocity < -0.4 || currentX - startX < -80){
      closeDrawer();
    }else{
      openDrawer();
    }
  },{passive:true});

})();
